<template>
  <div class="pay-state">
    <div class="tip-box" :class="[payState == 0 ? 'pt' : 'pt-res']">
      <div class="tip-icon">
        <span
          :class="[payState == 0 ? 'loading' : '', psImage[payState]]"
        ></span>
      </div>
      <div class="tip-title">{{ psTitle[payState] }}</div>
      <!-- 错误码: -->
      <div v-if="payState==2">({{$t('bstext.bs68')}}{{errorCode}})</div>
    </div>
    <div class="btn-box" v-if="payState == 1">
      <!-- 完成 -->
      <bs-button class="w100" @click="paySuccess">{{$t('bstext.bs69')}}</bs-button>
    </div>
    <div class="btn-box" v-if="payState == 2">
      <!-- 重新支付 -->
      <bs-button class="w100 mb" @click="rePay">{{$t('bstext.bs70')}}</bs-button>
      <!-- 取消支付 -->
      <bs-button type="gray" class="w100" @click="cancelPay">{{$t('bstext.bs71')}}</bs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderNo: "",
      payState: 0, //0加载中,1支付成功,2失败
      psImage: ["bs-icon-loading", "bs-icon-success", "bs-icon-error"],
      // psTitle: ["加载中...", "支付成功!", "支付失败!"],
      psTitle: [`${this.$t('bstext.bs72')}...`, `${this.$t('bstext.bs73')}!`, `${this.$t('bstext.bs74')}!`],
      // pgTitle: ["页面跳转中", "支付成功", "支付失败"],
      pgTitle:[`${this.$t('bstext.bs75')}`, `${this.$t('bstext.bs73')}`, `${this.$t('bstext.bs74')}`],
      errorCode: "",
    };
  },
  computed:{
    billInfoFlag(){
      return this.$store.state.billInfoFlag
    }
  },
  mounted() {  
    this.orderNo = this.$route.query.orderNo;
    document.title = this.pgTitle[this.payState]
    this.getPayStatus()
  },
  methods: {
    getPayStatus(){
      let req = {
        order_no: this.orderNo,
      };      
      this.$server.getPayStatus(req).then(res=>{
            this.payState = res.data.ok == 1 ? 1 : 2;
            this.errorCode = res.data.err_code;
            document.title = this.pgTitle[this.payState]
      }).catch(res=>{
            this.payState=2
            this.errorCode = res.state;
            document.title = this.pgTitle[this.payState]
      })
    },
    rePay(){
      this.$router.replace(`/bs/battswap/payway?ono=${this.orderNo}`)
    },
    cancelPay(){
      if(this.billInfoFlag==1){
        this.$router.replace('/bs/battswap/currentbill')
      }else{
        this.$router.replace(`/bs/battswap/billdetail/${this.orderNo}`)
      }
    },
    paySuccess(){
      if(this.billInfoFlag==1){
        this.$router.replace('/bs/battswap/currentbill')
      }else{
        this.$router.replace(`/bs/battswap/billdetail/${this.orderNo}`)
      }
    }
  },
};
</script>

<style lang="less" scoped>
.pay-state {
  height: 100%;
  background: #f7f8fa;
  .pt {
    padding-top: 42.6vw;
  }
  .pt-res {
    padding-top: 21.3vw;
  }
  .tip-box {
    text-align: center;
    // padding-top: 42.6vw;
    .tip-icon {
    }
    .tip-title {
      line-height: 18px;
      margin-top: 32px;
      font-size: 18px;
      color: #21242c;
    }
    .loading {
      transition: transform 1s;
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
  .btn-box {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 40px;
    width: 100%;
    .mb {
      margin-bottom: 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/pay/paystate.vue